import { apiConstants } from "../../../../utils/apiConstants";
import { apiTypes } from "../../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../../utils/getAxiosCancelToken";
import apiRequestType from "../../../apiRequestType";

let cancelToken;
const getAssignedClass = () => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.GRAPHICAL_REPORT.GET_ASSIGNED_CLASS,
    cancelToken
  );
};

export default getAssignedClass;
